import React, { FC, useContext, useState } from "react";
import { Context } from "../../..";
import ModalSuccess from "../../Shared/ModalWindows/ModalSuccess";
import ModalError from "../../Shared/ModalWindows/ModalError";
import { isAxiosError } from "axios";
import LicenseUpload from "./LicenseUpload";

interface IActivateLicenseInitialProps {
    onActivate: () => void;
    serverId?: string;
}

const ActivateLicenseInitial: FC<IActivateLicenseInitialProps> = ({
    onActivate,
    serverId,
}) => {
    const { store } = useContext(Context);
    const [error, setError] = useState<string>();
    const [success, setSuccess] = useState<boolean>(false);

    const handleCloseError = () => {
        setError(undefined);
        setSuccess(false);
    };

    const handleCloseSuccess = () => {
        setError(undefined);
        setSuccess(false);
        onActivate();
    };

    if (success) {
        return <ModalSuccess onClose={handleCloseSuccess} headerText="Успешно" />;
    }
    if (error) {
        return (
            <ModalError
                bodyText={error}
                headerText="Ошибка"
                onClose={handleCloseError}
            />
        );
    }

    const handleActivate = async (file: File) => {
        try {
            await store.licenseService.activateLicense(file);
            setSuccess(true);
        } catch (err) {
            if (isAxiosError(err)) setError(err.response?.data.message);
        }
    };

    return (
        <LicenseUpload
            onActivate={handleActivate}
            showCloseElements={false}
            serverId={serverId}
        />
    );
};

export default ActivateLicenseInitial;
